'use es6';

import { Component } from 'react';
import styled from 'foundations-theming/utils';
import { Z_INDEX_MAX_LAYERS } from '../lib/layoutSection/constants';

// &[data-hs-cos-type*] styles allows click events to pass through for those types
import { jsx as _jsx } from "react/jsx-runtime";
const StyledClickCatcher = styled.div.withConfig({
  displayName: "ClickCatcher__StyledClickCatcher"
})(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  opacity: 0,
  zIndex: Z_INDEX_MAX_LAYERS.LEVEL_1
}));

// This component is only used in layout mode, we may be able to deprecate this soon
/**
 * @param {Function} props.onClickCallback (required)
 */
export default class ClickCatcher extends Component {
  constructor(...args) {
    super(...args);
    this.onClick = () => {
      this.props.onClickCallback();
    };
  }
  render() {
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized: hs-private for StyledClickCatcher
      _jsx("div", {
        className: "hs-private",
        children: /*#__PURE__*/_jsx(StyledClickCatcher, {
          onClick: this.onClick
        })
      })
    );
  }
}